(function($, Drupal) {
  Drupal.behaviors.quote_uploads = {
    attach: function(context, settings) {
      const $set_progress = $('.view-quote-status-step-1');
      const $set_coverage = $('#set-select-coverage');
      const $policy_upload = $('.field--name-field-policy').length;
      const $upload_error = $('#upload-error');
      const $upload_success = $('#upload-success'); // JBB - 2023-10-10 - added to control showing the checkmark icon in the file upload column
      const $submit_uploads = $('#submit-uploads');
      // const $upload_fields = $('#document-uploads').find('form > button');
      const $change_status = $('#change-status').find('form > button').first();

      let $questionnaire_complete = false;
      let $all_filled = false;
      let $upload_field_index;

      function disable_inputs() {
        if ($('*:contains("No Documents Added")').length === 0) {
          $all_filled = true;
          $upload_error.removeClass('shown');
          $upload_success.addClass('shown');
        }
        else {
          $all_filled = false;
          $upload_error.addClass('shown');
          $upload_success.removeClass('shown');
        }

        // JBB - 2023-11-03 - added check for "Association Details Completed" to enable the submit button
        if ($('*:contains("Association Details Completed")').length !== 0) {
          $questionnaire_complete = true;
        }

        // Enable submit buttons
        if ($all_filled && $questionnaire_complete) {
          // $upload_error.removeClass('shown');
          // $upload_success.addClass('shown');
          $submit_uploads.prop('disabled', false);
          $('#non-partnered-submit').prop('disabled', false);
        }
        else {
          $submit_uploads.prop('disabled', true);
        }
      }

      /* Function starts the load of a designated upload field,
         once the ajax request is complete it recalls this function for the next upload field,
         when there are no more upload fields, the status update form is submitted and the page is reloaded.
      */
      // JBB - 2023-11-03 - we no longer need to do this fancy fake-button-pressing for each upload field, because aleaquo_media_types.module handles saving the file to the association. but we still need to change the association status with a fake button press.
      //     However, we want to change
      function submit_uploads(index) {
        $change_status.mousedown();
        $(document).on('ajaxComplete', function() {
          location.reload();
        });

        // if ($upload_fields[index] !== undefined) {
        //   $($upload_fields[index]).mousedown();

        //   $(document).on('ajaxComplete', function() {
        //     $upload_field_index = index + 1;
        //     submit_uploads($upload_field_index);
        //   });
        // }
        // else {
        //   $change_status.mousedown();
        //   $(document).on('ajaxComplete', function() {
        //     location.reload();
        //   });
        // }
      }

      // Setting 'quote-in-progress' status behind the scenes on the step 1 view
      if ($set_progress.length) {
        // Auto check upload documents, disable button
        $('.field--name-field-quote-status .form-submit').text('Submit');

        // Only apply if NOT uploading policy files
        if ($policy_upload === 0) {
          $('#edit-field-quote-status option:contains("Quote in Progress")').prop('selected', true);
          $('.view-quote-status-step-1').once('watch-fields').each(function() {
            disable_inputs();
            new MutationObserver(function() {
              disable_inputs();
            }).observe(this, {childList: true, subtree: true});
          });
        }

        $submit_uploads.once('submit-documents').on('click', function() {
          if ($policy_upload === 0) {
            if ($('*:contains("No Documents Added")').length === 0) {
              $('.step-section').addClass('loading');
              $submit_uploads.prop('disabled', true);
              $upload_field_index = 0;
              submit_uploads($upload_field_index);
            }
          }
        });
      }

      if ($set_coverage.length) {
        $('#edit-field-quote-status option:contains("Finalize Paperwork")').prop('selected', true);

        $('#edit-select').on('click', function(event) {
          $set_coverage.find('.js-form-submit').first().mousedown();
        });
      }

      // Non partnered document uploads
      // JBB - 2023-11-13 - updated media library upload/remove functionality eliminates the need for a "Submit Documents" button in the non-partnered /quote-comparisoon/XXXX page.
      // $('.node--view-mode-quote-status-non-partnered-agent').once('add-non-partner-submit').append('<button class="button" type="button" id="non-partnered-submit">Submit Documents</button>');
      $('.node--view-mode-quote-status-non-partnered-agent input').prop('disabled', false);
      $('#non-partnered-submit').click(function() {
        $('*[id*=edit-submit]:visible').once('trigger-updates').each(function(i) {
          $(this).mousedown();
        });
      });
    }
  };
})(jQuery, Drupal);
